import React, { useEffect } from "react";
import $ from "jquery";

const Boardofdirector = ({ imgObject }) => {
  useEffect(() => {
    $("[data-bg-img]").each(function () {
      $(this).css("background-image", "url(" + $(this).data("bg-img") + ")");
    });
    $("[data-margin-top]").each(function () {
      $(this).css("margin-top", $(this).data("margin-top"));
    });
  }, []);
  return (
    <>
      {/* <!-- Section: inner-header --> */}
      <section
        className="inner-header divider parallax layer-overlay overlay-dark-5"
        data-bg-img={imgObject.bgImage}
      >
        <div className="container pt-70 pb-20">
          {/* <!-- Section Content --> */}
          <div className="section-content">
            <div className="row">
              <div className="col-md-12">
                <h2 className="title text-white">Board of Directors</h2>
                <ol className="breadcrumb text-left text-black mt-10">
                  <li>
                    <a href="#">Home</a>
                  </li>
                  <li>
                    <a href="#">About us</a>
                  </li>
                  <li className="active text-gray-silver">
                    Board of Directors
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Section: --> */}
      <section className="">
        <div className="container">
          <div className="section-title text-center">
            <div className="row">
              <div className="col-md-12 ">
                <h2 className="text-uppercase line-bottom-double-line-centered mt-0">
                  {" "}
                  <span className="text-theme-colored2">
                    Board of Directors
                  </span>
                </h2>
              </div>
            </div>
          </div>

          <div className="section-content">
            <div className="pad-top10px pad-bottom20px research_teambios">
              <div className="general">
                <div className="row nopading">
                  <div className="graybg">
                    <div className="col-md-4 col-sm-12 nopading">
                      <div className="research_teambios-right">
                        <div className="img-box">
                          <img src={imgObject.kkk} alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8 col-sm-12 nopading">
                      <div className="research_teambios-right">
                        <div className="textcontent">
                          <h5 className="text-uppercase text-left">
                            Mr. Kayes Khalil Khan
                          </h5>
                          <p className="text-left">Chairman</p>
                          <p style={{ "text-align": "justify" }}>
                            Mr. Kayes Khalil Khan entails 20+ years of rich experience in multiple domains including administering and managing operations, business development,  corporate activities and administration ensuring the operations performed as per set global and organizational standards. Mr. khan is currently  spearheading as Executive Director with United Enterprises and Company Ltd. (United Group), he has successfully handled day to day procurement and corporate operations for the organization including coordinating with clients, developing National and international relations on behalf of the organization and starting new ventures.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                            Mr. Khan hold significant experience in implementing corporate strategies and control systems to achieve corporate objectives by identifying and developing potential investment opportunities. He possess all-rounder intellect along with blending leadership skills with sound analysis and implementation practices to achieve turn around growth and position for organization long term profitability. He believes that United Group must grow sustainably and also uphold its brand value.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr></hr>
              <div className="general">
                <div className="row nopading">
                  <div className="graybg">
                    <div className="col-md-8 col-sm-12 nopading">
                      <div className="research_teambios-left">
                        <div className="textcontent">
                          <h5 className="text-uppercase text-right">
                            Mr. Moinuddin Hasan Rashid
                          </h5>
                          <p className="text-right">Director</p>
                          <p style={{ "text-align": "justify" }}>
                            Mr. Moinuddin Hasan Rashid, the Managing Director of
                            United Securities Limited, was born in 1982 in
                            Dhaka. Upon completion of his B.Sc. in Electrical
                            and Electronics Engineering from University College
                            London, he joined United Group in 2005 as a second
                            generation Director. As a young and energetic
                            entrepreneur, he marked his future through
                            dedication, dynamism, and foresight in shaping the
                            Power Sector, one of the major enterprises of the
                            United Group. On 12 July 2011, he was appointed as
                            Managing Director of United Enterprises & Co. Ltd,
                            and simultaneously holds the position of the
                            Managing Director for United Power Generation and
                            Distribution Co. Ltd. and many more sister concerns.
                            Mr. Rashid is an Active Trustee of the United Trust,
                            a CSR organization of the Group and United
                            International University Foundation.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                            In 2011 he oversaw the commissioning of 208 MW Power
                            Generation under three projects (KPCL II, KJAPCL &
                            UAPL). United Ashuganj Power Ltd. (UAPL) is a quick
                            rental power plant that was constructed and
                            commissioned in a record time of 120 days under the
                            tireless and bold leadership of Mr. Rashid. He also
                            established United Property Solutions Ltd. one of
                            the leading real estate developers of the country
                            and oversaw the development of United Land Port
                            Teknaf Ltd, Bangladesh’s only land port with
                            Myanmar. Along with the responsibilities mentioned
                            above, he looks after Group Investment and Business
                            Development. Mr. Moinuddin Hasan Rashid supervised
                            Power Plant expansion projects of UPGDCL DEPZ and
                            UPGDCL CEPZ by 75 MW, oversaw commissioning of
                            United Energy Ltd., formerly known as Shajahanullah
                            Power Generation Co Ltd, a 28 MW Power Plant, and
                            spearheaded the Joint-Venture of Gunze United
                            Limited in 2013. Mr. Rashid also established United
                            Shipping and Logistics Services Ltd. in 2015.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                            Currently, Mr. Rashid is the Managing Director or
                            United Power Generation & Distribution Co. Ltd.
                            (UPGDCL), United Ashuganj Power Ltd. (UAPL), United
                            Ashuganj Energy Ltd. and United Property Solutions
                            Ltd. (UPSL) and is in the Board of Directors of
                            United Hospital Ltd. (UHL), Khulna Power Company
                            Ltd. (KPCL) and United Landport Teknaf Ltd. (ULPTL).
                            He is also an active member of the Board of Trustees
                            of United International University (UIU). Mr. Rashid
                            is also the Joint General Secretary of the Board of
                            Trustees United International University, Trustee of
                            the Social Services & Management Trust, Sir John
                            Wilson School and Joint Convener of DCCI Standing
                            Committee.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 col-sm-12 nopading">
                      <div class="research_teambios-right">
                        <div class="img-box">
                          <img src={imgObject.mhr} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>              
              <hr></hr>
              <div className="general">
                <div className="row nopading">
                  <div className="graybg">
                  <div className="col-md-4 col-sm-12 nopading">
                      <div className="research_teambios-right">
                        <div className="img-box">
                          <img src={imgObject.kma} alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8 col-sm-12 nopading">
                      <div className="research_teambios-right">
                        <div className="textcontent">
                          <h5 className="text-uppercase text-left">
                            Mr. Khondokar Moinul Ashan Shamim
                          </h5>
                          <p className="text-left">Director</p>
                          <p style={{ "text-align": "justify" }}>
                            Mr. Khandaker Moinul Ahsan Shamim, is one of the
                            Directors of United Securities Limited. After
                            completion of his Bachelor of Commerce, he joined
                            the business together with a few like-minded
                            friends. With his diligence and exceptional
                            entrepreneurial skills, he played important roles in
                            establishing firm footing and quick expansion of
                            business of the Group. At one time he also undertook
                            the responsibility of United Group in the capacity
                            of the Managing Director, displaying his
                            entrepreneurial skill and business experience, in
                            order to sustain growth of business of United Group.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                            At present, he is one of the Directors of all the
                            corporate entities of United Group, notably United
                            Enterprises & Co. Ltd., United Power Generation and
                            Distribution Company Ltd., United Hospital Limited,
                            Khulna Power Company Ltd., etc. He oversees the
                            overall financial management of the Group on behalf
                            of the Board of Directors. Besides this, he is also
                            a member, Board of Trustees of United International
                            University.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                            He plays key role in the social development sector
                            of his home district. Being one of the active
                            Trustees of the United Trust, a CSR organization of
                            the Group, he generously patronizes education sector
                            in his home village and surrounding areas.
                          </p>
                        </div>
                      </div>
                    </div>                    
                  </div>
                </div>
              </div>
              <hr></hr>
              <div className="general">
                <div className="row nopading">
                  <div className="graybg">
                    <div className="col-md-8 col-sm-12 nopading">
                      <div className="research_teambios-left">
                        <div className="textcontent">
                          <h5 className="text-uppercase text-right">
                            Mr. Kutubuddin Akhter Rashid
                          </h5>
                          <p className="text-right">Director</p>
                          <p style={{ "text-align": "justify" }}>
                          Mr. Kutubuddin Akhter Rashid began his professional career at United Group in 2018 as a Management Associate in UECL – Power Division. He was posted on site at Mymensingh to be involved as a core project team member for United Jamalpur Power Ltd. and United Mymensingh Power Ltd. Upon successful completion of the projects in Mymensingh, he was transferred to Chattogram to supervise the implementation of United Anwara Power Ltd., which led to commissioning in June 2019.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                          As a young entrepreneur, Mr. Kutubuddin Akhter Rashid’s involvement in business has imbued well with the core values of the Group. His keen sense of professionalism and ability to lead projects in strict timeframes led to his appointment as the Associate Director of United Enterprises & Co. Ltd. in 2020 and as Director of UECL in 2023. He took charge of United Payra Power Ltd. project, and amid Covid pandemic outbreak, his careful planning and prudent decisions during project execution, led to on time commissioning of the project.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                          Mr. Kutubuddin Akhter Rashid is currently in charge of the Power Division of United Group with an objective to optimize operational efficiency in the ongoing projects. He also leads the planning and design phase of new/upcoming projects that the Group is interested to invest in. Additionally, he is the Managing Director of Leviathan Global (BD) Ltd. and United Healthcare Services Ltd.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                          Mr. Kutubuddin Akhter Rashid serves as Director on the board of United Payra Power Ltd, United Ashuganj Energy Ltd, United Hospital.
                          </p>                          
                          <p style={{ "text-align": "justify" }}>
                          Mr. Kutubuddin Akhter Rashid completed his bachelor’s degree in Public Relations & Marketing from Taylor’s University, Malaysia.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 col-sm-12 nopading">
                      <div class="research_teambios-right">
                        <div class="img-box">
                          <img src={imgObject.kar} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr></hr>
              <div className="general">
                <div className="row nopading">
                  <div className="graybg">
                    <div className="col-md-4 col-sm-12 nopading">
                      <div className="research_teambios-right">
                        <div className="img-box">
                          <img src={imgObject.nhr} alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8 col-sm-12 nopading">
                      <div className="research_teambios-right">
                        <div className="textcontent">
                          <h5 className="text-uppercase text-left">
                            Mr. Nizamuddin Hasan Rashid
                          </h5>
                          <p className="text-left">Director</p>
                          <p style={{ "text-align": "justify" }}>
                          Mr. Rashid began his career in the Tea estate industry, gaining valuable experience in operational efficiency and resource management. This foundation was crucial as he transitioned into real estate, expanding his expertise across sectors such as Ready-Mix Concrete (RMC) and heavy equipment. His diverse background equipped him with a deep understanding of the real estate ecosystem, vendor margins, and negotiation strategies, which proved instrumental in expanding United Group’s healthcare business.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                          As the Managing Director of United Healthcare, Mr. Rashid oversees a 630-bed hospital and leads the Group’s ventures into medical colleges, hospitals, time-centered healthcare facilities, and multi-facility businesses. His leadership is characterized by a commitment to delivering high-quality healthcare at the lowest possible cost. Each venture under his guidance presents unique challenges, requiring distinct operational strategies, all of which he manages effectively.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                          Mr. Rashid’s vision is to ensure the sustainable growth of United Healthcare, benefiting both the country and its stakeholders. He strives to continuously innovate within the healthcare sector, providing top-tier services at affordable rates. By integrating diverse business operations and fostering a holistic approach, he aims to strengthen the nation’s healthcare infrastructure and contribute to overall development.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr></hr>
              <div className="general">
                <div className="row nopading">
                  <div className="graybg">
                    <div className="col-md-8 col-sm-12 nopading">
                      <div className="research_teambios-left">
                        <div className="textcontent">
                          <h5 className="text-uppercase text-right">
                            Mr. Khandaker Zahin Ahsan
                          </h5>
                          <p className="text-right">Director</p>
                          <p style={{ "text-align": "justify" }}>
                            Mr. Khandaker Zahin Ahsan is the Director of United Securities Ltd., where he advises clients on investment opportunities with a primary focus on blue-chip stocks. He provides insights into market movements and conducts comprehensive analyses based on rigorous research and prevailing economic conditions to help clients maximize their returns. In partnership with the board of directors, he actively seeks new investment opportunities and works to expand the firm’s dealer portfolio.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                            Mr. Ahsan completed high school at Indus International School in Bengaluru, earning an International Baccalaureate diploma. He then pursued higher education in the United States, obtaining a Bachelor’s degree in Business Administration with a specialization in Entrepreneurship from the esteemed Zicklin School of Business at CUNY Baruch College in New York.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                            He began his career at Comilla Spinning Mills Ltd., where he gained hands-on experience in the transformation of raw cotton into yarn—a key process in the nation’s apparel industry. His involvement in operations, quality control, and sales provided him with a thorough understanding of the sector’s essential role in the country’s economy.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                            As United Group transitions responsibilities to the second generation, Mr. Ahsan remains committed to upholding the Group’s legacy through sustainable and ethical growth. He emphasizes steady, reliable progress over rapid, unsustainable expansion, ensuring that all business decisions contribute to the nation’s broader development while upholding the highest standards of excellence.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 col-sm-12 nopading">
                      <div class="research_teambios-right">
                        <div class="img-box">
                          <img src={imgObject.kza} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr></hr>
              <div className="general">
                <div className="row nopading">
                  <div className="graybg">                    
                    <div className="col-md-4 col-sm-12 nopading">
                      <div className="research_teambios-right">
                        <div className="img-box">
                          <img src={imgObject.kac} alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8 col-sm-12 nopading">
                      <div className="research_teambios-left">
                        <div className="textcontent">
                          <h5 className="text-uppercase text-left">
                            Mr. Mohammad Khairul Anam Chowdhury (Sohel)
                          </h5>
                          <p className="text-left">
                            Managing Director
                          </p>
                          <p style={{ "text-align": "justify" }}>
                            Md. Khairul Anam Chowdhury is an industry veteran
                            with more than 20 years of experience in the
                            Bangladesh capital market. Majority portion of Mr.
                            Chowdhury’s illustrious career has been dedicated to
                            LankaBangla Securities Ltd. (LBSL), the largest
                            stock brokerage of the country, where he played
                            various important roles in different capacities,
                            mastering each and every aspect of the business.
                            Before joining USL, he was the CEO and Director of
                            LBSL for 4 years and before that he played the role
                            of COO for 5 years. Mr. Chowdhury was a nominated
                            director representing LBSL in the board of Midas
                            Finance Limited. He was an elected board member of
                            Chittagong Stock Exchange (CSE) for two consecutive
                            terms.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr></hr>
              <div className="general">
                <div className="row nopading">
                  <div className="graybg">
                    <div className="col-md-8 col-sm-12 nopading">
                      <div className="research_teambios-right">
                        <div className="textcontent">
                          <h5 className="text-uppercase text-right">
                            Mr. Md. Razib Al Mamun
                          </h5>
                          <p className="text-right">
                            Director
                          </p>
                          <p style={{ "text-align": "justify" }}>
                            Mr. Razib is a unique talent and valuable asset in
                            the brokerage industry of Bangladesh. His profound
                            selling skill and ability of being a trusted advisor
                            have made him one of the best of his kind in the
                            industry. He started his career in the FMCG sector
                            and later on moved to the hospitality industry. His
                            experience in these industries and his exceptionally
                            strong interpersonal and networking skills helped
                            him develop very strong industry connections which
                            paved the way to his stellar growth in the capital
                            market. Before joining USL, he was the Head of
                            Premium Brokerage at LankaBangla Securities Limited
                            (LBSL) and before that he was the Head of Corporate
                            Sales at BRAC EPL Stock Brokerage Limited. He joined
                            USL as a Director and Chief Operating Officer,
                            responsible for leading the sales team as well as
                            managing the operations of the company.
                          </p>
                        </div>
                      </div>
                    </div>                    
                    <div class="col-md-4 col-sm-12 nopading">
                      <div class="research_teambios-left">
                        <div class="img-box">
                          <img src={imgObject.ram} alt=""/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr></hr>
              <div className="general">
                <div className="row nopading">
                  <div className="graybg">                    
                    <div className="col-md-4 col-sm-12 nopading">
                      <div className="research_teambios-right">
                        <div className="img-box">
                          <img src={imgObject.azr} alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8 col-sm-12 nopading">
                      <div className="research_teambios-left">
                        <div className="textcontent">
                          <h5 className="text-uppercase text-left">
                            Mr. Md. Ashaduzaman Riadh, CFA, FRM
                          </h5>
                          <p className="text-left">
                            Director
                          </p>
                          <p style={{ "text-align": "justify" }}>
                            Md Ashaduzaman Riadh is the Chief Investment Officer
                            & Director at United Securities Limited. He oversees
                            the proprietary, clients and group equity portfolio
                            investment. He is also volunteering and leading the
                            CFA community as a member of the board of directors
                            at CFA Society Bangladesh.
                          </p>
                          <p style={{ "text-align": "justify" }}>
                            Previously, Mr. Riadh was the Strategic Portfolio
                            Manager of LankaBangla Securities Ltd, a leading
                            stock brokerage house in Bangladesh. He was
                            responsible for managing portfolios of negative
                            margin brokerage clients. He was also a member of
                            the management and HR committee of LankaBangla
                            Securities. Apart from these, he advised the
                            institutional/HNI equity portfolios. He is a CFA
                            Charterholder from CFA Institute, USA also he is a
                            Certified FRM (Financial Risk Manager) from GARP
                            (Global Association of the Risk Professionals), USA.
                            Md Ashaduzaman Riadh has graduated in Finance from
                            University of Dhaka.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr></hr>
              <div className="general">
                <div className="row nopading">
                  <div className="graybg">                    
                    <div className="col-md-8 col-sm-12 nopading">
                      <div className="research_teambios-right">
                        <div className="textcontent">
                          <h5 className="text-uppercase text-right">
                            Mr. Md. Mahfuzur Rahman
                          </h5>
                          <p className="text-right">
                            Director
                          </p>
                          <p style={{ "text-align": "justify" }}>
                            Mr. Rahman joined USL as a Director and Chief
                            Business Development Officer, responsible for
                            developing institutional and foreign trade business.
                            He looks after research, product development, and
                            strategic planning. Prior to joining USL, Mr. Rahman
                            was the Chief Investment Officer of Union Capital
                            Limited. Before that, he played significant role in
                            foreign business development as Head of Research in
                            LankaBangla Securities Limited (LBSL) where he led a
                            large and capable sell-side research team and
                            attained around 40% market share in foreign trade
                            business of the country. He started his career with
                            Mindspring Research, an independent research firm.
                            Mr. Rahman completed his BBA and MBA majoring in
                            Finance from the University of Dhaka.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 col-sm-12 nopading">
                      <div class="research_teambios-right">
                        <div class="img-box">
                          <img src={imgObject.mmr} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Boardofdirector;
